var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"siteFooter"},[_c('p',[_vm._v("免税システム スマートデタックス")]),_c('p',[_vm._v("サポートコールセンター 050-8882-6886")])])}]

export { render, staticRenderFns }